import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { MessageService, TreeNode } from 'primeng/api';
import * as _ from 'lodash';
import { FolderManagementService } from '../../../../framework/services/folder-mgmt.service'
import { EditEngagementMemoryServiceService } from '../../edit-engagement-memory-service/edit-engagement-memory-service.service'
import { EngagementManagementService } from '../../../../framework/services/engagement-mgmt.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { CategoryConstant } from 'src/app/shared/app-constants/category-constants';
import { LanguageService } from 'src/framework/services/language.service';
import { Console } from 'console';
import { IfStmt } from '@angular/compiler';


@Component({
  selector: 'app-folder-mgmt-edit',
  templateUrl: './folder-mgmt-edit.component.html',
  styleUrls: ['./folder-mgmt-edit.component.css']
})
export class FolderMgmtEditComponent implements OnInit {

  foldersList = [];
  selectedFolder: any;

  @Input() treeData: string;
  @Input() big: boolean;
  targetTreeData: any[] = [];
  maxSeed: number = 0;
  languageList: any[];
  languageLabels: any[] = [];
  folderPath: "";
  globalIdentitySeed: number = 0;
  templateNode: TreeNode[];
  deleteNodeObj: TreeNode;
  isVisible: boolean = false;
  updatedTreeStructure: any
  savedTreeStructure: any;

  selectedLanguageId: number;
  defaultEnglishJson: any;
  islabelLoaded: boolean = false;
  selectedAppLanguageJson: any;

  selectedLangLabelJson: any;
  defaultEngLangLabelJson: any;
  eventValue: any;

  @Output() showPreviousControl = new EventEmitter<string>();
  constructor(
    private folderService: FolderManagementService,
    private http: HttpClient,
    private engagementMemoryService: EditEngagementMemoryServiceService,
    private engagementService: EngagementManagementService, private router: Router,
    private spinner: NgxSpinnerService,
    private languageSerivce: LanguageService,
    private messageService: MessageService
  ) { }

  ngOnInit(): void {
    this.spinner.show();
    this.loadLanguageLabel()
    this.folderService.getFolderTemplate(0).then((value) => {
      this.folderService.getFolderTemplate(this.engagementMemoryService.getEngagementId()).then((response) => {
        if (response && response.length > 0) {
          if (value && value.length > 0) {
            for (let i = 0; i < value.length; i++) {
              //if (value[i].label != response[0].label)
              this.foldersList.push(value[i]);
            }
          }

          var count: Array<number>=[];
          if (response[0].children) {
            let i =0;
            response[0].children.forEach(childNode => {
            if(childNode.label==undefined)
            {
              count.push(i);
            }
            i = i+1;
          });
          }
          
          count.forEach( val =>{
            response[0].children.pop(response[0].children[val]);
          });

          this.savedTreeStructure = { ...response[0] };
          if (response.length > 0 && response[0].children.length > 0) {
            let x = this.getFolders(response[0]);
            this.targetTreeData = x.children.length > 0 ? x.children : [];
          }
        }
        this.spinner.hide()
      }).catch(() => {
        this.spinner.hide()
      }).catch(() => {
        this.spinner.hide()
      })
    })
  }

  onFolderSelection(event) {
    let clonedTreeStructure = { ...this.savedTreeStructure, children: [...this.savedTreeStructure.children] };
    if (event.value) {
      let index = clonedTreeStructure.children.findIndex(t => t.label.toLowerCase() == event.value.label.toLowerCase())
      if (index == -1) {
        this.updatedTreeStructure = { ...clonedTreeStructure };
        let folders = this.getFolders(this.updatedTreeStructure);
        this.eventValue = { ...event.value, styleClass: "childFolder", type: "folder", children: [...event.value.children] };
        folders.children.push(this.eventValue);
        this.targetTreeData = folders.children
      }
    }
  }

  update() {
    this.spinner.show();
    let treeSet = { ...this.savedTreeStructure };
    treeSet.children.push({ ...this.eventValue, styleClass: "childFolder", type: "folder" })
    this.folderService.saveFolderTemplate([treeSet], this.engagementMemoryService.getEngagementId()).subscribe((res) => {
      if (res.status == -1) {
        this.messageService.add({
          summary: this.labelReplacer('ErrorWhileUpdatingFolderTemplate'),
          detail: "",
          sticky: false,
          severity: 'error'
        });
      } else {
        this.messageService.add({
          summary: this.labelReplacer('SuccessfullyUpdatedFolderTemplate'),
          detail: "",
          sticky: false,
          severity: 'success'
        });
        this.selectedFolder = null;
        this.savedTreeStructure = treeSet;
      }
      this.spinner.hide();
    })
  }

  loadLanguageLabel() {
    let englishLanguageMappings, selectedLanguageMappings: any, englishLangLabelMappings, selectedLangLabelMappings: any;
    return new Promise((resolve, reject) => {
      this.languageSerivce.mySubject.subscribe((data) => {
        var languageMappings = data;
        if (languageMappings?.length > 0) {

          englishLanguageMappings = languageMappings.filter(item =>
            item?.categoryName?.toLowerCase() === CategoryConstant.AddEngagement.toLowerCase()
            && Number(item?.languageId) === 1)[0];

          englishLangLabelMappings = languageMappings.filter(item =>
            item?.categoryName?.toLowerCase() === CategoryConstant.Language.toLowerCase()
            && Number(item?.languageId) === 1)[0];

          if (englishLanguageMappings?.isGlobal) {
            selectedLanguageMappings = languageMappings.filter(item =>
              item?.categoryName?.toLowerCase() === CategoryConstant.AddEngagement.toLowerCase()
              && Number(item?.languageId) === Number(this.selectedLanguageId))[0];

            selectedLangLabelMappings = languageMappings.filter(item =>
              item?.categoryName?.toLowerCase() === CategoryConstant.Language.toLowerCase()
              && Number(item?.languageId) === Number(this.selectedLanguageId))[0];
          }
          else {
            if (Number(this.selectedLanguageId) === 2) {
              selectedLanguageMappings = languageMappings.filter(item =>
                item?.categoryName?.toLowerCase() === CategoryConstant.AddEngagement.toLowerCase()
                && Number(item?.languageId) === Number(this.selectedLanguageId))[0];

              selectedLangLabelMappings = languageMappings.filter(item =>
                item?.categoryName?.toLowerCase() === CategoryConstant.Language.toLowerCase()
                && Number(item?.languageId) === Number(this.selectedLanguageId))[0];
            }
            else {
              selectedLanguageMappings = englishLanguageMappings;
              selectedLangLabelMappings = englishLangLabelMappings;

            }
          }
          this.selectedAppLanguageJson = JSON.parse(selectedLanguageMappings.languageMappingJSON);

          this.defaultEnglishJson = JSON.parse(englishLanguageMappings.languageMappingJSON);

          this.selectedLangLabelJson = JSON.parse(selectedLangLabelMappings?.languageMappingJSON ?? englishLangLabelMappings.languageMappingJSON);
          this.defaultEngLangLabelJson = JSON.parse(englishLangLabelMappings.languageMappingJSON);

          this.islabelLoaded = true;
          resolve(1);
        }
        else {
        }
      });
    })
      .catch(err => {

        console.log(err);
      });
  }

  labelReplacer(labelKey): string {
    return this.selectedAppLanguageJson[labelKey]?.trim() ? this.selectedAppLanguageJson[labelKey] ?? 'text not found' : this.defaultEnglishJson[labelKey] ?? 'text not found';
  }

  resetFolderStructure(e) {
    this.selectedFolder = null;
    let savedTreeClone = this.getFolders(this.savedTreeStructure);
    this.targetTreeData = savedTreeClone.children;
  }



  getFolders(node) {
    let folderTreeData = { ...node };
    let childfolder = [];
    for (let i = 0; i < folderTreeData.children.length; i++) {
      if (folderTreeData.children[i].type == "folder") {
        let res = this.getFolders(folderTreeData.children[i])
        if (res.type == "folder")
          childfolder.push({ ...res });
      }
    }
    return { ...folderTreeData, children: childfolder };
  }
}
